import React from 'react'
import { useSelector } from 'react-redux'

import { userTypes } from 'constants/user'
import useVideoContext from 'hooks/useVideoContext/useVideoContext'

import {
    Controls,
    AddPages,
    Navigation,
    Icon,
    PageNumber,
    LeftIcon,
    RightIcon,
} from './styles'

const ICON_BASE_PATH = '/img/artefacts/whiteboard/toolbar'

const ControlBarBottom = ({
    onAddPage,
    onPrev,
    onNext,
    currentPage,
    totalPage,
    disableAddPage,
    disableLeftNavigation,
    disableRightNavigation,
}) => {
    const { userType, isWhiteboardMode } = useVideoContext()

    return (
        <Controls isWhiteboardMode={isWhiteboardMode}>
            <>
                <Navigation>
                    {userType === userTypes.TEACHER && (
                        <LeftIcon
                            src={`${ICON_BASE_PATH}/left.svg`}
                            alt="prev"
                            onClick={onPrev}
                            disableLeftNavigation={disableLeftNavigation}
                        ></LeftIcon>
                    )}
                    <PageNumber>
                        {currentPage}/{totalPage}
                    </PageNumber>
                    {userType === userTypes.TEACHER && (
                        <RightIcon
                            src={`${ICON_BASE_PATH}/right.svg`}
                            alt="next"
                            onClick={onNext}
                            disableRightNavigation={disableRightNavigation}
                        ></RightIcon>
                    )}
                </Navigation>
                {userType === userTypes.TEACHER && (
                    <AddPages
                        onClick={onAddPage}
                        disableAddPage={disableAddPage}
                    >
                        <Icon
                            src={`${ICON_BASE_PATH}/add.svg`}
                            alt="add page"
                        ></Icon>
                    </AddPages>
                )}
            </>
        </Controls>
    )
}

export default ControlBarBottom
